import '@ui5/webcomponents/dist/Label.js';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `Label` is a component used to represent a label, providing valuable information to the user. Usually it is placed next to a value holder, such as a text field. It informs the user about what data is displayed or expected in the value holder.
 *
 * The `Label` appearance can be influenced by properties, such as `required` and `wrappingType`. The appearance of the Label can be configured in a limited way by using the design property. For a broader choice of designs, you can use custom styles.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Label" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const Label = withWebComponent('ui5-label', ['for', 'wrappingType'], ['required', 'showColon'], [], []);
Label.displayName = 'Label';
export { Label };
